import type { AiDataPolicy } from './types';

export class AiDataPolicyConflictError extends Error {
  constructor(readonly current: AiDataPolicy) {
    super('ai_data_policy_conflict');
    this.name = 'AiDataPolicyConflictError';
  }
}

export class AiDataPolicyForbiddenError extends Error {
  constructor() {
    super('ai_data_policy_forbidden');
    this.name = 'AiDataPolicyForbiddenError';
  }
}

export class AiDataPolicyHistoryForbiddenError extends Error {
  constructor() {
    super('ai_data_policy_history_forbidden');
    this.name = 'AiDataPolicyHistoryForbiddenError';
  }
}
